import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import ResponsiveContainer from '../ResponsiveContainer/ResponsiveContainer.js';
import Alert from './Alert.js';

const Alerts = ({
  alerts = [],
  getDismissHandler,
  onClear
}) => {
  const handleKeyDown = e => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      onClear();
    }
  };
  if (alerts.length === 0) return null;
  return /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
    size: "sm",
    role: "presentation",
    onKeyDown: handleKeyDown,
    className: "nui-alerts_container"
  }, alerts.map(alert => /*#__PURE__*/React__default.createElement(Alert, _extends({
    key: alert.id
  }, alert, {
    onDismiss: getDismissHandler(alert)
  }))));
};
Alerts.displayName = 'NuiAlerts';
var Alerts$1 = Alerts;

export { Alerts$1 as default };
